import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Delay({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.TIME-MANAGEMENT.DELAY.';

    return (
        <div className="form-element">
            {t(label + 'HEADER')} <small>(ms)</small>
            <TextInput action={action} inputName="delay" variables={variables} setOpenVariable={setOpenVariable} isRequired />
            <small><em>{t(label + 'EG')}</em></small>
        </div>
    );
}
export default Delay;